/**
 * Marks dayjs values chosen from an advanced-filter date preset so we can
 * store the preset key (relative date) instead of inferring from calendar days.
 * Kept in sync with AdvancedFilter FilterRow + Input Date Range forwarding.
 */
export const ADVANCED_FILTER_DATE_PRESET_MARK = "__kayrosDatePresetKey";
